import { useGetVesselsGeoInfoMutation } from 'app/api/facade';
import { sortAreas } from 'app/helpers/sortAreasByTypeAndAlphabet';

interface AreasCellProps {
  mmsi: number;
}

export const AreasCell = ({ mmsi }: AreasCellProps) => {
  const [, { data }] = useGetVesselsGeoInfoMutation({
    fixedCacheKey: 'get-areas-mutation',
  });

  const vesselGeozones = data?.results?.find((ship) => ship.key === mmsi.toString())?.inAreas;

  if (!vesselGeozones?.length) return <>&mdash;</>;

  const userGeozones = sortAreas(vesselGeozones, 'USER');
  const commonGeozones = sortAreas(vesselGeozones, 'COMMON');
  const allGeozones = [...userGeozones, ...commonGeozones];
  const areasNames  = allGeozones.map((area) => area?.name || '').join(', ');

  return <>{ areasNames }</>;
};
